<template>
  <ResponsiveModal
    :variant="variant"
    :title="$t('components.task_export.title')"
    :confirmLabel="$t('components.task_export.submit_button')"
    :showCancel="!maxSmall"
    :disableConfirm="loading"
    tracking-id="tasks.export-xlsx"
    @confirm="exportTasks"
  >
    <slot>
      <Button variant="tertiary" size="2xs" iconOnly :disabled="loading">
        <template #start>
          <LoadingSpinner v-if="loading" />
          <Icon v-else name="download" size="sm" />
        </template>
      </Button>
    </slot>
    <template #content>
      <div class="w-full py-5 px-4 md:px-6 bg-primary">
        {{ $t("components.task_export.description") }}
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";
import route from "ziggy-js";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { toast } from "@/SharedComponents/Toaster";
import { Icon } from "@/SharedComponents/Icon";
import { Button } from "@/SharedComponents/Buttons";
import { LoadingSpinner } from "@/SharedComponents/LoadingSpinner";

const { t } = useI18n();
const { maxSmall } = useBreakpoints();

const props = defineProps({
  variant: { type: String, required: false },
  filters: { type: Object, required: true },
});
const filtersWithTimezone = computed(() => {
  return {
    ...props.filters,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
});

const loading = ref(false);

async function exportTasks() {
  loading.value = true;
  await axios
    .post(route("api.export.tasks"), filtersWithTimezone.value)
    .then(() => {
      toast.success(t("components.task_export.success"));
    })
    .catch((err) => {
      toast.error(err.message || t("components.task_export.error"));
    })
    .finally(() => (loading.value = false));
}
</script>
